import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import useMedia from 'hooks/useMedia';

import { Button } from '@Atomic/atoms/Button';
import { Text } from '@Atomic/atoms/Text';

import styles from './style.module.scss';

type Props = {
  className?: string;
  url: string;
};

export const OfferRelated = ({ className, url }: Props) => {
  const { t } = useTranslation();
  const { xs } = useMedia();

  return (
    <div className={cn(className, styles.card)}>
      <div className={styles.cardContent}>
        <div className={styles.description}>
          <Text className={styles.title}>{t('offer.relatedTitle')}</Text>

          <Text variant={xs ? 'medium' : 'large'}>{t('offer.relatedText')}</Text>
        </div>
      </div>

      <Button to={url} fullWidth className={styles.cardLink}>
        {t('offer.relatedLink')}
      </Button>
    </div>
  );
};
